import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Route, Switch } from "react-router-dom";
import { getAdminBasePath, getAdminBaseRoute } from "../AdminRoutes";
import TeamFormWrapper from "../../../../../components/teamAdmin/teamFormWrapper";
// Paths
export const getTeamAdminBasePath = () => `${getAdminBasePath()}/teamAdmin`;
export const getTeamAdminCreatePath = () => `${getTeamAdminBasePath()}/create`;
export const getTeamAdminEditPath = (id) => `${getTeamAdminBasePath()}/edit/${id}`;
// Routes
export const getTeamAdminBaseRoute = () => `${getAdminBaseRoute()}/teamAdmin`;
export const getTeamAdminCreateRoute = () => `${getTeamAdminBaseRoute()}/create`;
export const getTeamAdminEditRoute = () => `${getTeamAdminBaseRoute()}/edit/:id`;
const AdminTeamRoutes = () => {
    return (_jsxs(Switch, { children: [_jsx(Route, { component: TeamFormWrapper, path: getTeamAdminCreateRoute() }), _jsx(Route, { component: TeamFormWrapper, path: getTeamAdminEditRoute() })] }));
};
export default AdminTeamRoutes;
